import React, { FC } from 'react';
import 'react-tippy/dist/tippy.css';
import styled, { createGlobalStyle } from 'styled-components';
import { Tooltip as Tippy } from 'react-tippy';
import { Typography } from './Typography';
import { colors, space, global, shadows } from '../styles/tokens';
import { ThemeIconSizesKeys } from '../styles/tokens/iconSizes';
import { Close } from './icon/icons/Close';
import { TooltipInfo } from './icon/icons/TooltipInfo';
import { TooltipQuestion } from './icon/icons/TooltipQuestion';

const GlobalTooltipStyle = createGlobalStyle`
  .tippy-popper {
        .tippy-tooltip {
            background: ${colors.black.default};
            border-radius: ${global.borderRadius.default};
            padding: ${space.lg} ${space.md};
            max-width: 200px;
            box-shadow: ${shadows.default};
        }

        &[x-placement^=bottom] [x-arrow] {
            border-bottom: 7px solid ${colors.black.default};
        }

        &[x-placement^=top] [x-arrow] {
            border-top: 7px solid ${colors.black.default};
        }
    } 
`;

export interface TooltipProps {
  text: string;
  infoIcon?: boolean;
  tooltipIconSize?: ThemeIconSizesKeys;
}

export const StyledTippy = styled(Tippy)`
  background: transparent;
  cursor: pointer;
  color: currentColor;

  &:hover {
    color: ${colors.brand.default};
  }
`;

export const StyledTooltipClose = styled(Close)`
  position: absolute;
  right: ${space.sm};
  top: ${space.sm};
`;

export const Tooltip: FC<TooltipProps> = ({ text, infoIcon, tooltipIconSize }) => {
  if (!text) {
    return <></>;
  }
  return (
    <>
      <GlobalTooltipStyle />
      <StyledTippy
        html={
          <>
            <StyledTooltipClose size="extraSmall" />
            <Typography component="span" variant="bodySmall">
              {text}
            </Typography>
          </>
        }
        tabIndex={0}
        arrow
        tag="button"
        distance={8}
        interactive
      >
        <Typography component="span" variant="bodySmall" visuallyHidden>
          Toggle tool tip
        </Typography>
        {infoIcon ? (
          <TooltipInfo size={tooltipIconSize || 'extraSmall'} />
        ) : (
          <TooltipQuestion size={tooltipIconSize || 'extraSmall'} />
        )}
      </StyledTippy>
    </>
  );
};

export default Tooltip;
